export const WorksheetFieldsLayoutTestIds = {
  LAYOUT: 'worksheet-drawer.fields-layout',
  SECTION: 'worksheet-drawer.fields-layout.section',
  SECTION_TITLE: 'worksheet-drawer.fields-layout.section-title',
  FIELD: 'worksheet-drawer.fields-layout.field',
};
